import { render, staticRenderFns } from "./TractVisitTypeForm.vue?vue&type=template&id=66e10cb9&"
import script from "./TractVisitTypeForm.vue?vue&type=script&lang=js&"
export * from "./TractVisitTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports